import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=64fb8a8b&"
import script from "./TipTap.vue?vue&type=script&lang=js&"
export * from "./TipTap.vue?vue&type=script&lang=js&"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=64fb8a8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports